import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import FormikRichTextareaField from './FormikRichTextareaField';

import {
  STRING_FIELD_DESCRIPTION,
  STRING_FIELD_DESCRIPTION_OPTIONAL,
} from '../labels';

import FormikLabeledField from './FormikLabeledField';

import formikPropTypes from './formikPropTypes';

export function DescriptionField({
  name, formikProps, enableRichText,
}) {
  const { setFieldValue } = formikProps;

  // Update formik value when user types in pell editor
  const onPellEditorChange = useCallback((plainText) => {
    setFieldValue(name, plainText);
  }, [setFieldValue, name]);

  return (
    <FormikLabeledField
      as={enableRichText ? FormikRichTextareaField : 'textarea'}
      onChange={enableRichText ? onPellEditorChange : () => {}}
      name={name}
      formikProps={formikProps}
      label={STRING_FIELD_DESCRIPTION}
      placeholder={STRING_FIELD_DESCRIPTION_OPTIONAL}
    />
  );
}

DescriptionField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
  enableRichText: PropTypes.bool,
};

DescriptionField.defaultProps = {
  enableRichText: false,
};

export default DescriptionField;
